// extracted by mini-css-extract-plugin
export default {"parent":"paused_parent__oMiu6","wrapper":"paused_wrapper__GK6C6"};